<script setup>
  import { inject, ref, watch } from 'vue'
  import { NDataTable, NModal } from 'naive-ui'

  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()

  const ongoingUploadData = ref([])

  const uploadOnGoingFields = [
    {
      key: 'username',
      title: 'NAMEEON',
      sortable: false,
      visible: true,
      disabled: false,
    },
    {
      key: 'createdTimestamp',
      title: 'CREATED TIME',
      sortable: false,
      type: 'datetime',
      visible: true,
      disabled: false,
    },
    {
      key: 'file.name',
      sortable: true,
      title: 'FILE',
      visible: true,
    },
    { key: 'uploadStatus', sortable: true, title: 'STATUS', visible: true },
    {
      key: 'availableCount',
      sortable: true,
      title: 'AVAILABLE',
      visible: true,
    },
    {
      key: 'successCount',
      sortable: true,
      title: 'SUCCESS',
      visible: true,
    },
    {
      key: 'processedCount',
      sortable: true,
      title: 'PROCESSED',
      visible: true,
    },
    {
      key: 'completedCount',
      sortable: true,
      title: 'COMPLETED',
      visible: true,
    },
    {
      key: 'failedCount',
      sortable: true,
      title: 'FAILED',
      visible: true,
    },
    {
      key: 'rejectedCount',
      sortable: true,
      title: 'REJECTED',
      visible: true,
    },
    { key: 'actions', visible: true, title: 'ACTIONS' },
  ]

  watch(
    () => appStore.showUploadsOngoingModal,
    (isVisible) => {
      if (isVisible) {
        ongoingUploadData.value = [appStore.uploadsOngoingInfo]
      }
    }
  )
</script>

<template>
  <NModal
    v-model:show="appStore.showUploadsOngoingModal"
    preset="dialog"
    title="Upload Detail"
    :closable="true"
    style="width: 98vw"
  >
    <NDataTable
      :columns="uploadOnGoingFields"
      :data="ongoingUploadData"
    />
  </NModal>
</template>
